import { StorageValue } from './storage-value';

// -----------------------------------------------------------------------------
export class LocalStorage {
  // ---------------------------------------------------------------------------
  public static get keys(): string[] {
    return Object.keys(localStorage);
  }

  // ---------------------------------------------------------------------------
  public static get(key: string): StorageValue {
    const val = localStorage.getItem(key);
    return new StorageValue(val);
  }

  // ---------------------------------------------------------------------------
  public static getKeysByPrefix(prefix: string): string[] {
    const foundKeys: string[] = [];
    const keys = Object.keys(localStorage);

    keys.forEach((key) => {
      if (key.startsWith(prefix)) {
        foundKeys.push(key);
      }
    });

    return foundKeys;
  }

  // ---------------------------------------------------------------------------
  public static set(key: string, val: any): void {
    if (!val) {
      val = '';
    }

    localStorage.setItem(key, val);
  }

  // ---------------------------------------------------------------------------
  public static setNumber(key: string, val: number): void {
    localStorage.setItem(key, JSON.stringify(val));
  }

  // ---------------------------------------------------------------------------
  public static setBool(key: string, val: boolean): void {
    localStorage.setItem(key, JSON.stringify(val));
  }

  // ---------------------------------------------------------------------------
  public static remove(key: string): void {
    localStorage.removeItem(key);
  }

  // ---------------------------------------------------------------------------
  public static setObject(key: string, val: object): boolean {
    try {
      localStorage.setItem(key, JSON.stringify(val));
      return true;
    } catch (e) {
      return false;
    }
  }
}
